/// Auto-generated with ScanbotSDKCodegenV3. Modifications will be overwritten.
/// Generated from core/schemas/TextPatternScannerTypes.yaml
import { ToJsonConfiguration } from '../utils/json/JsonSerializationTypes';
import { PartiallyConstructible } from '../utils/utils';
export const PatternGrammarValues = ['WILDCARD', 'REGEX'];
/**
Structure containing recognized word text and bounds.
*/
export class WordBox extends PartiallyConstructible {
    /** @param source {@displayType `DeepPartial<WordBox>`} */
    constructor(source = {}) {
        super();
        /**
          Confidence of the recognition.
          
          Default is 0.0
          */
        this.recognitionConfidence = 0.0;
        if (source.text !== undefined) {
            this.text = source.text;
        }
        else {
            throw new Error('text must be present in constructor argument');
        }
        if (source.boundingRect !== undefined) {
            this.boundingRect = {
                x: source.boundingRect.x,
                y: source.boundingRect.y,
                width: source.boundingRect.width,
                height: source.boundingRect.height,
            };
        }
        else {
            throw new Error('boundingRect must be present in constructor argument');
        }
        if (source.recognitionConfidence !== undefined) {
            this.recognitionConfidence = source.recognitionConfidence;
        }
    }
    serialize(config = new ToJsonConfiguration()) {
        return {
            text: this.text,
            boundingRect: this.boundingRect,
            recognitionConfidence: this.recognitionConfidence,
        };
    }
}
/**
Structure containing recognized symbol text and bounds.
*/
export class SymbolBox extends PartiallyConstructible {
    /** @param source {@displayType `DeepPartial<SymbolBox>`} */
    constructor(source = {}) {
        super();
        if (source.symbol !== undefined) {
            this.symbol = source.symbol;
        }
        else {
            throw new Error('symbol must be present in constructor argument');
        }
        if (source.boundingRect !== undefined) {
            this.boundingRect = {
                x: source.boundingRect.x,
                y: source.boundingRect.y,
                width: source.boundingRect.width,
                height: source.boundingRect.height,
            };
        }
        else {
            throw new Error('boundingRect must be present in constructor argument');
        }
        if (source.recognitionConfidence !== undefined) {
            this.recognitionConfidence = source.recognitionConfidence;
        }
        else {
            throw new Error('recognitionConfidence must be present in constructor argument');
        }
    }
    serialize(config = new ToJsonConfiguration()) {
        return {
            symbol: this.symbol,
            boundingRect: this.boundingRect,
            recognitionConfidence: this.recognitionConfidence,
        };
    }
}
/**
The result of the text line recognition.
*/
export class TextPatternScannerResult extends PartiallyConstructible {
    /** @param source {@displayType `DeepPartial<TextPatternScannerResult>`} */
    constructor(source = {}) {
        super();
        /**
          Confidence of the recognition.
          
          Default is 0.0
          */
        this.confidence = 0.0;
        /**
          Whether the validation was successful.
          
          Default is false
          */
        this.validationSuccessful = false;
        if (source.rawText !== undefined) {
            this.rawText = source.rawText;
        }
        else {
            throw new Error('rawText must be present in constructor argument');
        }
        if (source.wordBoxes !== undefined) {
            this.wordBoxes = source.wordBoxes.map((it) => {
                return new WordBox(it);
            });
        }
        else {
            throw new Error('wordBoxes must be present in constructor argument');
        }
        if (source.symbolBoxes !== undefined) {
            this.symbolBoxes = source.symbolBoxes.map((it) => {
                return new SymbolBox(it);
            });
        }
        else {
            throw new Error('symbolBoxes must be present in constructor argument');
        }
        if (source.confidence !== undefined) {
            this.confidence = source.confidence;
        }
        if (source.validationSuccessful !== undefined) {
            this.validationSuccessful = source.validationSuccessful;
        }
    }
    serialize(config = new ToJsonConfiguration()) {
        return {
            rawText: this.rawText,
            wordBoxes: this.wordBoxes.map((it) => {
                return it.serialize(config);
            }),
            symbolBoxes: this.symbolBoxes.map((it) => {
                return it.serialize(config);
            }),
            confidence: this.confidence,
            validationSuccessful: this.validationSuccessful,
        };
    }
}
/** @internal */
export var ContentValidator;
(function (ContentValidator) {
    /** @internal */
    function From(source) {
        const _type = source['_type'];
        switch (_type) {
            case 'DefaultContentValidator':
                return new DefaultContentValidator(source);
            case 'PatternContentValidator':
                return new PatternContentValidator(source);
            default:
                throw `Unknown child class name: ${_type}`;
        }
    }
    ContentValidator.From = From;
})(ContentValidator || (ContentValidator = {}));
/**
Default content validator. Accepts only non-empty strings.
*/
export class DefaultContentValidator extends PartiallyConstructible {
    /** @param source {@displayType `DeepPartial<DefaultContentValidator>`} */
    constructor(source = {}) {
        super();
        this._type = 'DefaultContentValidator';
        /**
          OCR whitelist. Empty string means no restriction.
          
          Default is ""
          */
        this.allowedCharacters = '';
        if (source.allowedCharacters !== undefined) {
            this.allowedCharacters = source.allowedCharacters;
        }
    }
}
/**
Pattern content validator.
*/
export class PatternContentValidator extends PartiallyConstructible {
    /** @param source {@displayType `DeepPartial<PatternContentValidator>`} */
    constructor(source = {}) {
        super();
        this._type = 'PatternContentValidator';
        /**
          OCR whitelist. Empty string means no restriction.
          
          Default is ""
          */
        this.allowedCharacters = '';
        /**
          Whether the pattern should match the whole string or just a substring.
          
          Default is false
          */
        this.matchSubstring = false;
        /**
          Grammar of pattern matching.
          
          Default is WILDCARD
          */
        this.patternGrammar = 'WILDCARD';
        if (source.allowedCharacters !== undefined) {
            this.allowedCharacters = source.allowedCharacters;
        }
        if (source.pattern !== undefined) {
            this.pattern = source.pattern;
        }
        else {
            throw new Error('pattern must be present in constructor argument');
        }
        if (source.matchSubstring !== undefined) {
            this.matchSubstring = source.matchSubstring;
        }
        if (source.patternGrammar !== undefined) {
            this.patternGrammar = source.patternGrammar;
        }
    }
}
/**
Configuration for the text pattern scanner.
*/
export class TextPatternScannerConfiguration extends PartiallyConstructible {
    /** @param source {@displayType `DeepPartial<TextPatternScannerConfiguration>`} */
    constructor(source = {}) {
        super();
        /**
          Maximum image size (height or width) for OCR process. 0 - do not rescale.
          
          Default is 0
          */
        this.ocrResolutionLimit = 0;
        /**
          Maximum number of accumulated frames to inspect before actual result is returned.
          
          Default is 3
          */
        this.maximumNumberOfAccumulatedFrames = 3;
        /**
          Minimum number of accumulated frames that have equal result.
          
          Default is 2
          */
        this.minimumNumberOfRequiredFramesWithEqualScanningResult = 2;
        /**
          Content validator.
          */
        this.validator = new DefaultContentValidator({});
        if (source.ocrResolutionLimit !== undefined) {
            this.ocrResolutionLimit = source.ocrResolutionLimit;
        }
        if (source.maximumNumberOfAccumulatedFrames !== undefined) {
            this.maximumNumberOfAccumulatedFrames = source.maximumNumberOfAccumulatedFrames;
        }
        if (source.minimumNumberOfRequiredFramesWithEqualScanningResult !== undefined) {
            this.minimumNumberOfRequiredFramesWithEqualScanningResult =
                source.minimumNumberOfRequiredFramesWithEqualScanningResult;
        }
        if (source.validator !== undefined) {
            this.validator = ContentValidator.From(source.validator);
        }
    }
}
//# sourceMappingURL=TextPatternScannerTypes.js.map